import React, { CSSProperties, Ref } from 'react';
import styled from 'styled-components';
import { path } from 'ramda';
import { Row, Space } from 'antd';

type Props = {
  title?: string;
  titleSize?: string;
  children: React.ReactNode;
  full?: boolean;
  margin?: string;
  wrapperStyle?: CSSProperties;
  width?: number;
  elemRef?: Ref<HTMLDivElement>;
  error?: React.ReactNode;
};

const CardWrapper = styled.div<{ margin?: string; full: boolean | undefined; width?: number }>`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: ${(props) => (props.full ? 'left' : 'center')};
  padding: 16px;
  background-color: ${path(['theme', 'colors', 'grey', 'lighter'])};
  border-radius: 4px;
  width: ${(props) => (props.full ? '100%' : '50%')};
  margin: ${(props) => (props.margin ? props.margin : '0 auto 24px auto')};
  max-width: ${(props) => (props.full ? 'inherit' : props.width ? `${props.width}px` : '400px')};
`;

const CardTitle = styled.div<{ size?: string }>`
  font-size: ${({ size, theme }) => (size ? size : theme.font.size.h3)};
  font-weight: bold;
`;

const Card: React.FC<Props> = ({
  title,
  titleSize,
  children,
  full,
  margin,
  width,
  wrapperStyle,
  elemRef,
  error,
}: Props) => (
  <CardWrapper style={wrapperStyle} full={full} margin={margin} width={width} ref={elemRef}>
    {title && (
      <Row align="middle" style={{ marginBottom: 16 }}>
        <CardTitle size={titleSize}>{title} </CardTitle>
        {error && (
          <Space direction="horizontal" size="small">
            {error}
          </Space>
        )}
      </Row>
    )}
    {children}
  </CardWrapper>
);
export default Card;
